/**
 * FixedPagination - Paginazione fissa per le pagine
 * Rimane sempre visibile in fondo al contenuto
 */

import React, { ReactNode } from 'react';
import { Box } from '@mui/material';

interface FixedPaginationProps {
  children: ReactNode;
  marginTop?: number | string;
}

const FixedPagination: React.FC<FixedPaginationProps> = ({ 
  children, 
  marginTop = 2 
}) => {
  return (
    <Box sx={{ 
      flexShrink: 0,
      mt: marginTop,
      backgroundColor: 'background.paper',
      borderTop: '1px solid',
      borderColor: 'divider',
      p: 1,
      position: 'sticky',
      bottom: 0,
      zIndex: 1
    }}>
      {children}
    </Box>
  );
};

export default FixedPagination;
